var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTimelineBorder = function SvgTimelineBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 51 751"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B9B9B9",
    strokeDasharray: "12 12",
    strokeWidth: 2,
    d: "M29.738 1.363c-92.498 172.074 74.499 497.864 0 749"
  })));
};
export default SvgTimelineBorder;